import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 后台删除队伍
export const deleteTeams = params => {
  return reqGet("get", "/app-yijiu-backstage/deleteTeams", params);
};

// 转让队伍
export const transferTeamAdmins = params => {
  return reqGet("get", "/app-yijiu-backstage/transferTeamAdmins", params);
};


// 热门队伍设置 - 查询热门队伍设置队伍列表
export const getHotTeamList = params => {
    return reqGet("get", "/app-yijiu-backstage/getHotTeamList", params);
};

// 手续费设置- 查询队伍创建的初始服务费
export const getTeamFeeInfo = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamFeeInfo", params);
};

// 热门队伍设置 - 设置热门队伍排序 teamIds队伍id集合 用逗号分割 格式 1,2,3
export const setHotTeamSort = params => {
  return reqGet("get", "/app-yijiu-backstage/setHotTeamSort", params);
};


// 手续费设置- 一键批量所有队伍费率
export const updateAllTeamFee = params => {
  return reqGet("get", "/app-yijiu-backstage/updateAllTeamFee", params);
};


// 手续费设置- 服务费修改
export const updateTeamFee = params => {
  return reqGet("get", "/app-yijiu-backstage/updateTeamFee", params);
};


// 手续费设置- 修改队伍创建的初始服务费
export const updateTeamFeeInfo = params => {
  return reqGet("get", "/app-yijiu-backstage/updateTeamFeeInfo", params);
};



// 查询用户设置列表
export const getAdminUserList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAdminUserList", params);
};

// 查询队伍列表
export const getAdminTeamList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAdminTeamList", params);
};

//队伍管理- 查询队伍管理员列表
export const getTeamAdminLists = params => {
  return reqGet("get", "/app-yijiu-backstage/getTeamAdminLists", params);
};



// 队伍管理- 提现金额.手续费统计
export const getTeamPremiumList = params => {//teamId   page  size startDate endDate
  return reqGet("get", "/app-yijiu-backstage/getTeamPremiumList", params);
};


// 修改模板演示分类  
export const updateCategory = params => {
  return req("post", "/app-yijiu-backstage/updateCategory", params);
};

// 队伍启用/禁用
export const updateTeamState = params => {//teamId   state
  return reqGet("get", "/app-yijiu-backstage/updateTeamState", params);
};

//队伍管理- 开启/关闭提现功能
export const updateTeamPayout = params => {//teamId   payout
  return reqGet("get", "/app-yijiu-backstage/updateTeamPayout", params);
};

//队伍管理- 修改取号最大金额上限
export const updateTeamMaxNumMoney = params => {//teamId   maxNumMoney
  return reqGet("get", "/app-yijiu-backstage/updateTeamMaxNumMoney", params);
};





// WEBPACK FOOTER //
// ./src/api/manage/team.js